import $ from 'jquery';
import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation } from 'swiper/modules';
import LazyImages from '../../../components/lazy-images';
import Cookies from 'js-cookie';
export default class BannerSlider {
    static $topSlider = $('.js__shop-banner-slider').eq(0);
    static $bottomSlider = $('.js__shop-banner-slider').eq(1);
    static topSwiper;
    static bottomSwiper;
    static sliderBannerOptions = {
        modules: [Autoplay, EffectFade, Navigation],
        speed: 600,
        autoplay: {
            delay: 6000,
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        loop: true,
        slidesPerView: 1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        on: {
            init: () => {
                this.makeOnlyActiveSlideNavigatable();
            },
            slideNextTransitionStart: () => {
                this.makeOnlyActiveSlideNavigatable();
            },
            slidePrevTransitionStart: () => {
                this.makeOnlyActiveSlideNavigatable();
            },
        },
    };
    static init() {
        if ((!this.$topSlider.length && !this.$bottomSlider.length) || !Cookies.get('age_confirmed')) {
            return;
        }
        this.topSwiper = this.initSwiper(this.$topSlider);
        this.bottomSwiper = this.initSwiper(this.$bottomSlider);
        LazyImages.update();
    }
    static initSwiper($slider) {
        if (!$slider.length) {
            return;
        }
        const isSingleSlide = $slider.find('.swiper-slide').length === 1;
        if (!isSingleSlide) {
            return new Swiper($slider.get(0), this.sliderBannerOptions);
        }
    }
    static makeOnlyActiveSlideNavigatable() {
        $('.swiper-slide.swiper-slide-active a').attr('tabindex', '0');
        $('.swiper-slide:not(.swiper-slide-active) a').attr('tabindex', '-1');
    }
    static stopAutoplay($sliderElement) {
        const $swiperContainer = $sliderElement.closest('.js__shop-banner-slider');
        if ($swiperContainer.is(this.$topSlider) && this.topSwiper) {
            this.topSwiper.autoplay.stop();
        }
        else if ($swiperContainer.is(this.$topSlider) && this.bottomSwiper) {
            this.bottomSwiper.autoplay.start();
        }
    }
    static startAutoplay($sliderElement) {
        const $swiperContainer = $sliderElement.closest('.js__shop-banner-slider');
        if ($swiperContainer.is(this.$topSlider) && this.topSwiper) {
            this.topSwiper.autoplay.start();
        }
        else if ($swiperContainer.is(this.$topSlider) && this.bottomSwiper) {
            this.bottomSwiper.autoplay.start();
        }
    }
}
